
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"130","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M124 40.5C109.95 61.573 88.728 75 65 75S20 61.573 6 40.5C20 19.427 41.272 6 65 6s44.999 13.427 59 34.5z","stroke":"#F3DE18","stroke-width":"11","stroke-miterlimit":"10","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M65.334 55.564c9.102 0 16.481-7.397 16.481-16.521 0-9.125-7.379-16.521-16.481-16.521-9.103 0-16.482 7.396-16.482 16.52 0 9.125 7.38 16.522 16.482 16.522z","stroke":"#F3DE18","stroke-width":"11","stroke-miterlimit":"10","stroke-linejoin":"round"}})])
          )
        }
      }
    